import { useState, useEffect } from "react";
import { SlidingNumber } from "./../SlidingNumber.jsx";

function RelojEnVivo() {
  const [hours, setHours] = useState(new Date().getHours());
  const [minutes, setMinutes] = useState(new Date().getMinutes());
  const [seconds, setSeconds] = useState(new Date().getSeconds());
  const [is24HourFormat, setIs24HourFormat] = useState(new Date().getHours() >= 12 ? "PM" : "AM");

  useEffect(() => {
    const timerId = setInterval(() => {
      const now = new Date();
      setHours(now.getHours());
      setMinutes(now.getMinutes());
      setSeconds(now.getSeconds());
      setIs24HourFormat(now.getHours() >= 12 ? "PM" : "AM");
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  const formatHours = hours % 12 || 12;

  return (
    <div className="gap-1 font-mono text-2sm bg-transparent backdrop-blur-lg shadow-lg rounded-full px-4 py-2 h-[25px] w-[150px] flex items-center gap-2 transition-all duration-300 ease-in-out transition-all duration-300 hover:shadow-[0_0_20px_5px_rgba(58,199,255,0.6)] hover:border-cyan-500">
      <SlidingNumber value={formatHours} padStart={true} />
      <span className="text-zinc-500">:</span>
      <SlidingNumber value={minutes} padStart={true} />
      <span className="text-zinc-500">:</span>
      <SlidingNumber value={seconds} padStart={true} />
        <span className="ml-2 text-xs text-zinc-500">{is24HourFormat}</span> 
       {/*  { ( is24HourFormat <= 12 ) ? <span className="ml-2 text-xs text-zinc-500">AM</span> : <span className="ml-2 text-xs text-zinc-500">PM</span> 
            } */}     
    </div>
  );
}

export default RelojEnVivo;
